import { DigitalFormsTypes } from '@frontend/api-digital-forms';
import { SubmissionDateFilter } from './submission-list-view.types';

export const DEFAULT_SUBMISSIONS_DATE_FILTER: SubmissionDateFilter = 'all';
export const DEFAULT_SUBMISSIONS_SORT_ORDER = DigitalFormsTypes.SchemaMessages.Order.DESC;
